import { createContext, useContext } from 'react';

interface AppShellContextValue {
  /** Below 768px the rail is a drawer, opened from the page's top bar. */
  isPhone: boolean;
  /** The full rail is showing, logo included, so the top bar leaves its own out. */
  railOpen: boolean;
  /** The page's top bar shows the logo: a phone's, and today's beside a collapsed rail. Studio B keeps it in the rail. */
  logoInBar: boolean;
  openNav: () => void;
}

export const AppShellContext = createContext<AppShellContextValue | null>(null);

export const useAppShell = () => useContext(AppShellContext);
